var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.415,
    height: 20.203,
    viewBox: "0 0 16.415 20.203",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M62.836,2.525H59.364V1.894A1.894,1.894,0,0,0,57.47,0H54.945a1.894,1.894,0,0,0-1.894,1.894v.631H49.578A1.578,1.578,0,0,0,48,4.1V5.366A.631.631,0,0,0,48.631,6H63.783a.631.631,0,0,0,.631-.631V4.1A1.578,1.578,0,0,0,62.836,2.525Zm-8.523-.631a.632.632,0,0,1,.631-.631H57.47a.632.632,0,0,1,.631.631v.631H54.313Z",
    transform: "translate(-48)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M73.561,184a.2.2,0,0,0-.2.207l.521,10.932a1.892,1.892,0,0,0,1.892,1.8h9.588a1.892,1.892,0,0,0,1.892-1.8l.521-10.932a.2.2,0,0,0-.2-.207Zm9.534,1.578a.631.631,0,1,1,1.263,0v8.207a.631.631,0,1,1-1.263,0Zm-3.157,0a.631.631,0,1,1,1.263,0v8.207a.631.631,0,1,1-1.263,0Zm-3.157,0a.631.631,0,1,1,1.263,0v8.207a.631.631,0,1,1-1.263,0Z",
    transform: "translate(-72.363 -176.74)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash-icon.35a3cb534ab67a61df9d04e55398f648.svg";
export { ForwardRef as ReactComponent };